import { legacyColors } from '~/legacyTheme';
import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    notificationIcon: {
      color: legacyColors.blue,
      paddingRight: theme.spacing(1),
      cursor: 'pointer',
      font: 'normal normal normal 14px/1 FontAwesome',
    },
    title: { color: legacyColors.white },
    pageTitle: { color: legacyColors.blue },
    paperActions: {
      marginLeft: 'auto',
      marginRight: 0,
      paddingRight: '20px',
    },
    notificationList: {
      minWidth: '600px',
      minHeight: '100px',
      fontSize: '14px',
    },
    notificationListItems: {
      maxHeight: '320px',
      overflow: 'auto',
    },
    notificationListTop: {
      display: 'flex',
      padding: '9px 6px',
      backgroundColor: legacyColors.blue,
      fontWeight: 'bold',
      alignItems: 'center',
    },
    notificationListTopPage: {
      display: 'flex',
      padding: '9px 6px',
      marginLeft: '15px',
      fontWeight: 'bold',
    },
    allNotificationsLink: {
      marginRight: '20px',
    },
    deleteAllLink: {
      marginLeft: '20px',
    },
    btnLink: {
      border: 'none',
      background: 'none',
      fontSize: '14px',
      fontWeight: 'inherit',
    },
    paperAction: {
      color: legacyColors.blue2,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
        cursor: 'pointer',
      },
    },
    paperActionPage: {
      color: legacyColors.blue,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
        cursor: 'pointer',
      },
    },
    markAllReadIcon: {
      margin: theme.spacing(0.25),
      marginRight: theme.spacing(0.5),
    },
    notiPanelMid: {
      top: '40px',
      overflowY: 'auto',
      color: '#111',
    },
    notiPanelMidPaper: {
      maxHeight: '320px',
    },
  };
};
